import type { ContractFamilyGroupDraft } from "@/types/billing";

/**
 * Value equality of two family-group drafts. The payers step and the contract
 * details form skip a parent update when this is true, so every field a user
 * action can change must be compared; otherwise, e.g., a "create new" click
 * that only sets `accountChoiceMade` never reaches the parent.
 */
export function areFamilyGroupDraftsEqual(
  a?: ContractFamilyGroupDraft,
  b?: ContractFamilyGroupDraft
): boolean {
  if (!a && !b) return true;
  if (!a || !b) return false;
  if (
    a.id !== b.id ||
    a.familyName !== b.familyName ||
    a.billingType !== b.billingType ||
    (a.unifiedBillingEmail || "") !== (b.unifiedBillingEmail || "") ||
    !!a.accountChoiceMade !== !!b.accountChoiceMade
  ) {
    return false;
  }
  if (a.members.length !== b.members.length) return false;
  return a.members.every((member, i) => {
    const other = b.members[i];
    return (
      member.contactId === other.contactId &&
      (member.paymentPercentage || 0) === (other.paymentPercentage || 0)
    );
  });
}
